import { BranchFeatureAccessor } from 'services/branch'
import useBranch from './use-branch'

type Result = { [key in BranchFeatureAccessor]?: boolean } | null

const useBranchFeature = (): Result => {
  const { masterBranch } = useBranch()

  if (!masterBranch) {
    return null
  }

  const { features } = masterBranch

  const branchFeatures =
    features?.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.accessor]: curr.is_active,
      }),
      {},
    ) ?? null

  return branchFeatures
}

export default useBranchFeature
